import { ExternalValueProps } from 'app/area/code-mappings/components/types';
import React from 'react';
import { Textarea } from 'ui';

export const ExternalValue = (props: ExternalValueProps) =>
  <Textarea
    label={{ text: props.label }}
    value={props.description ? `${props.id} (${props.description})` : props.id}
    readOnly={true} />;
